<!-- Header -->
<header #header class="sticky-top">
  <app-title />
  <app-navigation />
</header>

<!-- Content -->
<main>
  <router-outlet />
</main>

<!-- Footer -->
<app-footer />